/** An account named with its masked number: "Wells Fargo Checking (••1008)"; the bare name when it has none. */
export default function formatAccountLabel(account: { name: string; mask?: string | null }): string {
  return account.mask ? `${account.name} (••${account.mask})` : account.name;
}
